/**
 * @ngInject
 */
function videoResizer () {

    function onWindowResize () {
        iframe.style.height = el.offsetWidth/ratio+"px";
    }

    function link (scope, elem, attrs) {
        el = elem[0];
        if (el.className === 'vimeo') {
            iframe = el.querySelector('iframe');
            ratio = iframe.getAttribute("width") / iframe.getAttribute("height");
            window.addEventListener('resize', _.debounce(onWindowResize, 250));
            onWindowResize();
        }
    }

    var el, iframe, ratio;

    return {
        restrict : 'A',
        link : link
    };
}